import { useState } from 'react';
import apiService from '../../axios/apiService';

const useCaseTransactionStatus = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const getData = async (caseId) => {
    // Fetch data
    try {
      setLoading(true);
      const response = await apiService.getCaseTransactionStatus(caseId);
      response && setData(response); // update data state
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    getData,
  };
};

export default useCaseTransactionStatus;
